export const getNextYear = (): number => {
    const currentYear = new Date().getFullYear();

    return currentYear + 1;
}

export const getLastDayOfMonth = (date: Date) => {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0)
}
